<template>
  <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">Set your new password</h2>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow-lg sm:rounded-lg sm:px-10">
        <div v-if="message" :class="isError ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'" class="p-4 rounded-md">
          <p class="text-sm">{{ message }}</p>
          <router-link v-if="!isError" to="/login" class="font-bold underline">Click here to log in.</router-link>
        </div>
        <form v-else @submit.prevent="submitReset" class="space-y-6">
          <div>
            <label for="password" class="block text-sm font-medium text-gray-700">New Password</label>
            <input v-model="password" id="password" type="password" required class="w-full mt-1 px-3 py-2 border rounded-md">
          </div>
          <div>
            <label for="confirmPassword" class="block text-sm font-medium text-gray-700">Confirm New Password</label>
            <input v-model="confirmPassword" id="confirmPassword" type="password" required class="w-full mt-1 px-3 py-2 border rounded-md">
          </div>
          <div>
            <button type="submit" class="w-full flex justify-center py-2 px-4 rounded-md text-white bg-blue-600 hover:bg-blue-700" :disabled="isLoading">
              <span v-if="isLoading">Resetting...</span>
              <span v-else>Reset Password</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import axios from '../services/axiosInstance'

const password = ref('')
const confirmPassword = ref('')
const isLoading = ref(false)
const message = ref('')
const isError = ref(false)
const token = ref(null)
const route = useRoute()

onMounted(() => {
  token.value = route.query.token || null
  if (!token.value) {
    message.value = 'Invalid or missing password reset token.'
    isError.value = true
  }
})

const submitReset = async () => {
  if (password.value !== confirmPassword.value) {
    message.value = 'Passwords do not match.'
    isError.value = true
    return
  }

  isLoading.value = true
  message.value = ''
  isError.value = false
  try {
    const response = await axios.post('/reset-password', {
      token: token.value,
      password: password.value
    })
    message.value = response.data
  } catch (error) {
    message.value = error.response?.data || 'An error occurred. The link may have expired.'
    isError.value = true
  } finally {
    isLoading.value = false
  }
}
</script>
